<template>
  <NavigationToolbar :title="title">
    <Spinner :loading="true"></Spinner>
  </NavigationToolbar>
</template>

<script>
import Spinner from '@/components/Spinner'
import NavigationToolbar from '@/layouts/NavigationToolbar'

import { getFirstRouteFromPermissions } from '@/helpers/routePermissions'

export default {
  name: 'redirectIndex',
  components: {
    NavigationToolbar,
    Spinner
  },

  data: () => ({
    firstRoute: null,
    title: 'Maple Bear PWA'
  }),

  watch: {
    firstRoute (newValue) {
      this.$router.push(newValue)
    }
  },

  async mounted () {
    this.firstRoute = await getFirstRouteFromPermissions()
  }
}
</script>
